module.exports = __webpack_public_path__ + "static/schmink2-18539275c7c365a7c078801446aca225.jpg";